/* eslint-disable prettier/prettier */
import { LanguageTranslationsDto } from "@citychallenge/api-public";

export const translations: LanguageTranslationsDto[] = [
  {
    "id": "en",
    "name": "English",
    "translations": {},
    "enabled": true
  },
  {
    "id": "nl",
    "name": "Dutch",
    "translations": {
      "German": "Duits",
      "Belgian": "Belgisch",
      "answers": "antwoorden",
      "answer": "antwoord",
      "carousel": "carrousel",
      "Next slide": "Volgende slide",
      "Previous slide": "Vorige slide",
      "Slide {{index}} of {{total}}": "Slide {{index}} van {{total}}",
      "Correct answer given!": "Juiste antwoord gegeven!",
      "Wrong answer given!": "Verkeerde antwoord gegeven!",
      "Pause background video": "Pauzeer achtergrond video",
      "Resume background video": "Hervat achtergrond video",
      "Answer is correct": "Antwoord is juist",
      "Answer is wrong": "Antwoord is onjuist",
      "Play video": "Speel video af",
      "Mute video": "Zet geluid van video uit",
      "Unmute video": "Zet geluid van video aan",
      "Show transcript": "Laat transscriptie zien",
      "Transcript": "Transscriptie",
      "Close transcript": "Sluit transscriptie",
      "Please enter your professional email address": "Vul je professionele e-mailadres in",
      "An email with a login link has been sent to {{mail}}.": "Er is een e-mail met een login link verzonden naar {{mail}}.",
      "Don't have access to your email on this device? Use the verification code instead.": "Heb je geen toegang tot je e-mail op dit apparaat? Gebruik dan de verificatiecode.",
      "Could not sign-in": "We konden je niet inloggen",
      "Webinar via WebinarGeek": "Webinar via WebinarGeek",
      "Your display name": "Je weergavenaam",
      "Your display name (required)": "Je weergavenaam (verplicht)",
      "I prefer to participate in live events anonymously": "Ik ben liever anoniem tijdens live events",
      "Set up your account": "Stel je account in",
      "Almost there! Fill out the fields below to complete your profile.": "Bijna klaar! Vul hieronder de velden in om je profiel af te ronden.",
      "Select your work context below (optional)": "Selecteer hieronder je werkcontext (optioneel)",
      "Select your work context": "Selecteer jouw werkcontext",
      "The token you used is expired or invalid. Please login in again.": "De link of verificatiecode die je hebt gebruikt is verlopen of ongeldig. Log opnieuw in.",
      "The sign-in link is invalid or has expired.": "De link die je hebt gebruikt is verlopen of ongeldig.",
      "Back to sign-in": "Terug naar inloggen",
      "Contact person": "Contactpersoon",
      "Select one option.": "Selecteer één optie.",
      "Select {{amount}} options.": "Selecteer {{amount}} opties.",
      "Select at least one option.": "Selecteer minimaal één optie.",
      "Select at least {{amount}} options.": "Selecteer minimaal {{amount}} opties.",
      "Select a maximum of one option.": "Selecteer maximaal één optie.",
      "Select a maximum of {{amount}} options.": "Selecteer maximaal {{amount}} opties.",
      "Select at least {{min}} and at most {{max}} options.": "Selecteer minimaal {{min}} en maximaal {{max}} opties.",
      "Menu": "Menu",
      "Your account": "Jouw account",
      "Logged in as {{user.name}}": "Ingelogd als",
      "Your score": "Jouw score",
      "Continue": "Volgende",
      "Close": "Sluit",
      "Ok": "Oké",
      "Yes": "Ja",
      "No": "Nee",
      "Cancel": "Annuleer",
      "You are not logged in.": "Je bent ingelogd als",
      "Let's go": "Start",
      "Play": "Start",
      "Name": "Naam",
      "Points": "Punten",
      "Log in": "Log in",
      "Log out": "Log uit",
      "n/a": "n.b.",
      "Settings": "Instellingen",
      "Help & Support": "Hulp & Ondersteuning",
      "Privacy policy": "Privacybeleid",
      "Hide": "Verberg",
      "Mysterious location": "Mysterieuze locatie",
      "Owned": "In bezit",
      "Missing": "Ontbrekend",
      "Free": "Gratis",
      "{{numChallenges}} challenges": "{{numChallenges}} challenges",
      "Please enter a valid zipcode.": "Vul een geldige postcode in.",
      "Something went wrong during login": "Er is iets fout gegaan tijdens het inloggen",
      "Google Play services not installed on this devices.": "Google Play diensten zijn niet geïnstalleerd op dit appartaat.",
      "The login was cancelled": "De login is geannuleerd.",
      "There already is a login in progress": "Er is al een login bezig.",
      "Logging in has failed": "Inloggen is niet gelukt.",
      "You are already logged in.": "Je bent al ingelogd.",
      "You entered an invalid e-mail address.": "Je hebt een onjuist e-mailadres ingevuld.",
      "The token you entered is invalid or has expired.": "De code die je hebt ingevuld is ongeldig of verlopen.",
      "We couldn't reach our login server. Please check if you are connected to the internet.": "We kunnen geen verbinding maken met onze server, kijk of je wel verbinding hebt met het internet.",
      "Check answer": "Controleer antwoord",
      "Congratulations!": "Gefeliciteerd!",
      "Want to share something about\n your experience?": "Wil je iets met ons delen over je ervaring?",
      "Add your review here...": "Voeg hier je review toe...",
      "Actions": "Acties",
      "vote": "stem",
      "votes": "stemmen",
      "Help": "Help",
      "Are you sure?": "Weet je het zeker?",
      "Are you sure you want to perform this action?": "Weet je zeker dat je hiermee door wilt gaan?",
      "Hint #{{number}}": "Hint #{{number}}",
      "Request another hint": "Vraag om een extra hint",
      "Hints ({{num}} of {{total}} used)": "Hints ({{num}} van de {{total}} gebruikt)",
      "Type your answer here...": "Vul hier je antwoord in...",
      "English": "Engels",
      "Something went wrong.": "Er is iets mis gegaan.",
      "This code is not recognized by the app.": "Deze code wordt niet herkent door de app.",
      "Completed": "Voltooid",
      "Timebonus": "Tijdbonus",
      "{{num}} hint": "{{num}} hint",
      "{{num}} hints": "{{num}} hints",
      "{{num}} mistake": "{{num}} Fout",
      "{{num}} mistakes": "{{num}} Fouten",
      "You can do better!": "Je kan beter!",
      "We believe in you!": "Je kunt het!",
      "Don't give up!": "Geef niet op!",
      "It's the process that matters!": "Het gaat om het proces!",
      "You're great, but not the best!": "Je bent goed, maar niet de beste...",
      "Keep on trying!": "Blijf proberen!",
      "Aaaaahhw!": "Aaaaahhw!",
      "Go back": "Ga terug",
      "Skip": "Sla over",
      "Request a hint": "Vraag om een hint",
      "Dutch": "Nederlands",
      "Leaderboard": "Scorebord",
      "Restore purchases": "Zet aankopen terug",
      "This game could not be found.": "Dit spel is niet beschikbaar.",
      "This coupon code is invalid.": "Deze code is ongeldig.",
      "This coupon code has already been used.": "Deze code is al gebruikt.",
      "You already own the challenge for which this coupon code can be used!": "Je hebt de challenge al in bezit die bij deze code hoort.",
      "What is your gender?": "Wat is je geslacht?",
      "Male": "Man",
      "Female": "Vrouw",
      "Non-binary": "Niet-binair",
      "What is your age?": "Wat is je leeftijd?",
      "Please enter a nickname for the leaderboard": "Voer een nickname in voor het scorebord",
      "Type your nickname...": "Typ je nickname...",
      "Change your nickname": "Wijzig je nickname",
      "How would you like to be known in the leaderboard?": "Hoe wil je vermeld worden op het scorebord?",
      "Language": "Taal",
      "You just succesfully redeemed your access code! You are now the proud owner of '{{game}}'.": "De code is succesvol verwerkt! Je bent nu de trotse eigenaar van '{{game}}'.",
      "Unlock a challenge": "Ontgrendel een challenge",
      "It's possible to select multiple answers.": "Meerdere antwoorden mogelijk.",
      "Agree": "Eens",
      "Disagree": "Oneens",
      "The token you entered has expired.": "Het ingevoerde token is verlopen.",
      "Excellent!": "Uitstekend!",
      "Great!": "Super goed!",
      "Awesome!": "Geweldig!",
      "Doing good!": "Lekker bezig!",
      "Here, take some points!": "Hier, neem wat punten!",
      "You are doing great!": "Je doet het super goed!",
      "Stunning performance!": "Top prestatie!",
      "Go back to the main screen": "Ga terug naar het beginscherm",
      "Verification code": "Verificatiecode",
      "Use a different e-mail address": "Gebruik een ander mailadres",
      "Quit": "Stoppen",
      "Not connected to any company.": "Niet verbonden met een bedrijf.",
      "Events": "Events",
      "EnergyBoosters": "EnergyBoosters",
      "Academy": "Academy",
      "Content could not be found.": "Content kan niet worden gevonden.",
      "There are no articles yet.": "Er zijn nog geen artikelen.",
      "All": "Alle",
      "There are no articles that matches your search.": "Er zijn geen artikelen gevonden bij de zoekopdracht.",
      "The domain of your e-mail address is different than the allowed domain.": "De domeinnaam van jouw mailadres is anders dan het toegestane domein.",
      "You are no longer logged in, please log in again.": "Je bent niet meer ingelogd, log opnieuw in.",
      "Location": "Locatie",
      "There are no events yet.": "Er zijn nog geen evenementen.",
      "Time": "Tijd",
      "no details for this error.": "Geen details over deze foutmelding, oops.",
      "Unknown": "Onbekend",
      "Waiting list": "Wachtlijst",
      "Unsubscribe": "Afmelden",
      "No one yet, be the first!": "Nog niemand, wees de eerste!",
      "I want to join!": "Ik wil meedoen!",
      "Join waiting list": "Aanmelden voor de wachtlijst",
      "EnergyPoints": "EnergyPoints",
      "Coach": "Coach",
      "There is no coach for your company!": "Er is (nog) geen coach toegewezen.",
      "EnergyCoach": "EnergyCoach",
      "Hosted by": "Georganiseerd door",
      "Note: you can drag the screen to look around!": "Let op: je kunt het scherm slepen om rond te kijken!",
      "Earn": "Verdien",
      "Restart": "Herstarten",
      "Do you really want to start from the beginning? Warning: you will lose all of your progress!": "Wil je echt vanaf het begin starten? Waarschuwing: je verliest al je voortgang!",
      "Try again": "Probeer opnieuw",
      "You are attending": "Je staat op aanwezig",
      "Show": "Tonen",
      "You have successfully joined the event!": "Je bent succesvol ingeschreven voor het evenement!",
      "You have successfully joined the waiting list!": "Je bent succesvol op de wachtlijst geplaatst!",
      "Terms of service": "Servicevoorwaarden",
      "Sign up": "Inschrijven",
      "Please enter your email address and we'll send you a login link": "Voer je mailadres in om een inloglink te ontvangen",
      "Your professional email address": "Je professionele e-mailadres",
      "Your email address": "Jouw e-mailadres",
      "{{energyPoints}} point": "{{energyPoints}} punt",
      "{{energyPoints}} points": "{{energyPoints}} punten",
      "Reviews": "Reviews",
      "You have used all hints": "Je hebt alle hints gebruikt",
      "An error occurred while loading this content. Please check your internet connection and tap below to try again.": "Er is een fout opgetreden bij het laden van deze inhoud. Controleer de internetverbinding en tik hieronder om het opnieuw te proberen.",
      "You will lose your spot on the waiting list!": "Je zult je plek op de wachtlijst verliezen!",
      "French": "Frans",
      "Loading": "Laden",
      "About unlockables": "Over unlockables",
      "Compass instructions": "Kompas instructies",
      "Trivia": "Trivia quiz",
      "Story": "Story",
      "Minigames": "Minigame",
      "An error occurred while checking this code: {{error}}": "Er is een fout opgetreden bij het controleren van deze code: {{error}}",
      "Please enter an approved email address to login.": "Voer een goedgekeurd e-mailadres in om in te loggen.",
      "Your user account was successfully updated!": "Je gebruikersaccount is succesvol bijgewerkt!",
      "You can take as long as you want, but during some challenges you can earn a time bonus.": "Je kunt er zo lang over doen als je wilt, maar tijdens sommige uitdagingen kun je een tijdbonus verdienen.",
      "Hints": "Hints",
      "Are you stuck? Don't panic! You can ask for hints, each hint will cost you 20% of the points.": "Zit je vast? Geen paniek! Je kunt om hints vragen, elke hint kost je 20% van de punten.",
      "Giving a wrong answer will cost you 20% of the points.": "Een verkeerd antwoord geven kost 20% van de punten.",
      "Skipping": "Overslaan",
      "If you're really stuck, you can skip to the next challenge in the menu.": "Als je echt vastzit, kun je in het menu op overslaan drukken.",
      "Teams": "Teams",
      "Play with teams of {{minPlayers}} to max. {{maxPlayers}} people per device. Start 2 minutes after each other, this way your answers stay secret.": "Speel met teams van {{minPlayers}} tot max. {{maxPlayers}} mensen per telefoon. Begin 2 minuten na elkaar, zo blijven je antwoorden geheim.",
      "Play safe!": "Speel veilig!",
      "You're playing outside in a busy city, please be aware of traffic and other people around you.": "Je speelt buiten in een drukke stad, let op het verkeer en andere mensen om je heen.",
      "Start location": "Start locatie",
      "Don't forget to give a rating": "Vergeet niet een beoordeling te geven",
      "How was your experience?": "Hoe was de ervaring?",
      "Wrong answers": "Foute antwoorden",
      "Introduction": "Introductie",
      "Before you start, here are some explanations to help you during your challenge.": "Voordat je begint, volgt eerst een uitleg om te helpen tijdens de ervaring.",
      "Articles": "Artikelen",
      "An unspecified error occurred: {{message}} ": "Er is een onbekende fout opgetreden: {{message}} ",
      "Contact": "Contact",
      "Webinar via demio.com": "Webinar via demio.com",
      "Link becomes available when you sign up": "Link wordt beschikbaar wanneer je bent aangemeld",
      "Tap to join the session": "Tik om aan de sessie deel te nemen",
      "Getting started": "Aan de slag",
      "Something went wrong while connecting, please check your connection.": "Er ging iets mis tijdens het verbinden, controleer je internetverbinding.",
      "An unknown error occurred, please try again later.": "Een onbekende fout is opgetreden, probeer het later opnieuw.",
      "Change nickname": "Wijzig nickname",
      "Change picture": "Wijzig afbeelding",
      "Remove account": "Verwijder account",
      "Are you sure you want to remove your account? This may result in loss of purchases you have made on other platforms; purchases made via the {{storeName}} can be restored. All of your scores, reviews, content and progress will also be removed.": "Weet je zeker dat je jouw account wil verwijderen? Dit kan er voor zorgen dat je bepaalde aankopen kwijtraakt die je op andere platformen hebt gedaan; aankopen via de {{storeName}} kunnen altijd hersteld worden. All jouw scores, beoordelingen, inhoud en voortgang worden ook verwijderd.",
      "Your current account is not approved by '{{division}}'. \n Please log in with a different email address.": "Het huidige account is niet goedgekeurd door '{{division}}'. \nGelieve in te loggen met een ander mailadres.",
      "Incorrect credentials.": "Onjuiste gegevens.",
      "Are you sure you want to remove your account? All your scores, reviews, content and progress will also be removed.": "Weet je zeker dat je je account wilt verwijderen? Al je scores, beoordelingen, inhoud en voortgang zullen ook verwijderd worden.",
      "This city could not be found.": "Deze stad kon niet gevonden worden.",
      "Italian": "Italiaans",
      "Statement of consent": "Toestemmingsverklaring",
      "Your name": "Je naam",
      "Many spots available": "Veel plaatsen beschikbaar",
      "Are you sure you want to skip to the next scene?": "Weet je zeker dat je deze scène wilt overslaan?",
      "Go back to overview": "Ga terug naar het overzicht\n",
      "Start over": "Start opnieuw",
      "Rotation sensor": "Rotation sensor",
      "Age": "Leeftijd",
      "You": "Jij",
      "Submit": "Verzenden",
      "Start": "Start",
      "{{numReviews}} reviews": "{{numReviews}} beoordelingen",
      "Previous step": "Vorige stap",
      "You don't have access to this content.": "Je hebt geen toegang tot deze inhoud.",
      "You are not signed in. Please sign in.": "Je bent niet ingelogd. Gelieve in te loggen.",
      "Error while saving the data. Data already exists.": "Fout bij het opslaan van de gegevens. Gegevens bestaan al.",
      "An unspecified error occured. Please try again later, or contact us if this issue perists.": "Er is een fout opgetreden. Probeer het later nog eens, of neem contact met ons op als dit probleem zich blijft voordoen.",
      "+{{num}} points": "+{{num}} punten",
      "Disconnect environment": "Ontkoppel omgeving",
      "You don't have enough EnergyPoints to join this event.": "Je hebt niet genoeg EnergyPoints om aan dit evenement deel te nemen.",
      "Joining this event costs {{energyPoints}} EnergyPoints. Are you sure you want to join?": "Deelnemen aan dit evenement kost {{energyPoints}} EnergyPoints. Weet je zeker dat je mee wilt doen?",
      "You scored a total of **{{points}}** points. Let's see how you did compared to others:": "Je hebt in totaal **{{points}}** punten gescoord. Laten we eens kijken hoe je het deed in vergelijking met anderen:",
      "Choose language": "Kies taal",
      "Select a language from the dropdown below.": "Selecteer een taal uit het onderstaande menu.",
      "Powered by": "Powered by",
      "WARNING!": "WAARSCHUWING!",
      "Yes, I'm sure": "Ja, ik weet het zeker",
      "Danger zone": "Danger zone",
      "Welcome to {{locationName}}. It's up to you to disover the area. But first some steps to get you started.": "Welkom in {{locationName}}. Het is aan jou om het gebied te ontdekken. Maar eerst wat stappen om je op weg te helpen.",
      "Location access": "Locatie toegang",
      "In order to see your location on the map, the app needs access to your location.": "Om jouw locatie op de kaart te kunnen zien, moet de app toegang hebben tot je locatie.",
      "This feature is not supported by your current app version.": "Deze functie wordt niet ondersteund door je huidige app-versie.",
      "Scan the QR code to start": "Scan de QR-code om te beginnen",
      "Ready? Let's go!": "Klaar? Let's go!",
      "It's time to move to the nearest location, or any other location you choose to go!": "Het is tijd om naar de dichtstbijzijnde locatie te gaan, of een andere locatie naar keuze!",
      "Request": "Verzoek",
      "This link is not supported.": "Deze link wordt niet ondersteund.",
      "Verifying": "Verifiëren",
      "Yes, I agree to the [privacy policy]({{privacy}}) and [terms of service]({{terms}}).": "Ja, ik ga akkoord met het [privacybeleid]({{privacy}}) en de [servicevoorwaarden]({{terms}}).",
      "Sign in to {{division}}": "Meld je aan bij {{division}}",
      "Instructions": "Instructies",
      "Awaiting hotlink update...": "Wachten op hotlink update...",
      "This hotlink event is not supported yet in the web version. Please try the app instead.": "Deze hotlink actie wordt nog niet ondersteund in de web versie. Probeer het in de app.",
      "Tap the matching pairs.": "Tik op de juiste combinaties uit de linker en rechter kolom.",
      "True or false?": "Waar of niet waar?",
      "True": "Waar",
      "False": "Niet waar",
      "Drag screen": "Sleep op het scherm",
      "Move phone": "Beweeg telefoon",
      "Drag cursor": "Sleep cursor",
      "Error while playing media": "Fout tijdens het afspelen van media",
      "Profile": "Profiel",
      "Search for articles...": "Zoek artikelen...",
      "Live learning": "Live Learning",
      "Upload": "Upload",
      "Remove": "Verwijder",
      "Profile image": "Profiel afbeelding",
      "File is too large. Maximum file size is 2MB.": "Bestand is te groot. Maximale bestandsgrootte is 2MB.",
      "Delete account": "Verwijder account",
      "By deleting your account you will lose all progress.": "Door je account te verwijderen verlies je al je voortgang.",
      "Log out of your account and this environment.": "Log uit bij je account en deze omgeving.",
      "Save changes": "Opslaan",
      "Display name": "Weergavenaam",
      "Email address": "Email adres",
      "All EnergyPoints you have available on your account.": "Alle EnergyPoints die beschikbaar zijn op jouw account.",
      "Change the interface language of the app.": "Verander de interface taal van de app.",
      "Find {{num}} more": "Vind er nog {{num}}",
      "Woops! Try again.": "Oops! Probeer het opnieuw.",
      "Location permission": "Locatie toegang",
      "Location permission denied": "Toegang tot locatie geweigerd",
      "You have denied access to your location. Please refresh the page to try again. If this keeps happening, please check the permission settings of your browser.": "Je hebt toegang tot je locatie geweigerd. Probeer deze pagina te verversen om het opnieuw te proberen. Wanneer dit blijft gebeuren, controleer dan de instellingen van je browser.",
      "Refresh": "Ververs",
      "These icons represent locations you can visit. Get close and tap on them to start an interactive experience.": "Deze iconen geven locaties weer die je kunt bezoeken. Kom in de buurt en tap op een icoon om een interactieve ervaringen te starten.",
      "Are you sure you want to unsubscribe from this event? If there are people on the waiting list, your spot will go to them.": "Weet je het zeker? Als er mensen op de wachtlijst staan, wordt jouw plek vergeven.",
      "To overview": "Terug naar overzicht",
      "This experience contains features that only work on mobile devices. Scan the QR code with your mobile phone to get started.": "Deze ervaring bevat functies die alleen werken op mobiele telefoons. Scan de QR-code met je telefoon om te beginnen.\n",
      "Account settings": "Account instellingen",
      "{{remaining}} spots left": "{{remaining}} plaatsen beschikbaar",
      "{{remaining}} spot left": "{{remaining}} plaats beschikbaar",
      "Attending": "Aanwezig",
      "Read more": "Lees meer",
      "EnergyBooster": "EnergyBooster",
      "Article": "Artikel",
      "Event": "Event",
      "Level {{level}}": "Level {{level}}",
      "View": "Bekijk",
      "Welcome to {{divisionName}}": "Welkom bij {{divisionName}}",
      "Welcome, {{userName}}": "Welkom, {{userName}}",
      "Let's jump back in! Continue with '{{gameName}}'": "Laten we er weer in springen! Ga verder met '{{gameName}}'",
      "Congratulations! You have completed all {{experiences}}.": "Gefeliciteerd! Je hebt alle {{experiences}} voltooid.",
      "Continue {{experience}}": "Starten",
      "There are no {{experiences}} yet. Please check back later.": "Er zijn nog geen {{experiences}}. Kom later terug.",
      "Your total progress": "Je totale vooruitgang",
      "Back to previous step": "Terug naar de vorige stap",
      "Explore locations": "Locaties verkennen",
      "This content is no longer available.": "Deze inhoud is niet langer beschikbaar.",
      "Powered by Intractive": "Powered by Intractive",
      "Get closer to the spot indicated on the map to continue!": "Kom dichter bij de plek op de kaart om verder te gaan.",
      "Allow access to your rotation sensor for an optimal VR experience.": "Geef toegang tot de rotatiesensor voor een optimale ervaring.",
      "There are multiple correct answers.": "Er zijn meerdere juiste antwoorden.",
      "Link expired": "Link is verlopen",
      "Scan the QR code to open the map on your mobile phone:": "Scan de QR-code om de kaart te openen op je mobiele telefoon:",
      "Enable camera": "Camera inschakelen",
      " Request permission": "Toestemming geven",
      "Drag to skip": "Sleep om over te slaan",
      "Pick an option to continue": "Kies een optie om verder te gaan",
      "Time to read": "Tijd om te lezen",
      "Categories": "Categorieën",
      "Less than {{minutesReadTime}} minute": "Minder dan {{minutenReadTime}} min",
      "About {{minutesReadTime}} minutes": "Ongeveer {{minutenReadTime}} minuten",
      "Camera not working?": "Werkt de camera niet?",
      "If you can't get the camera to start, click on the button below.": "Als je de camera niet kunt starten, klik dan op de onderstaande knop.",
      "Continue without camera": "Doorgaan zonder camera",
      "On waiting list": "Op de wachtlijst",
      "Level {{level}} of {{total}}": "Level {{level}} van {{total}}",
      "Get started with your first {{experience}}!": "Begin met je eerste {{experience}}!",
      "Are you ready to start your your next {{experience}}?": "Ben je klaar om aan je volgende {{experience}} te beginnen?",
      "The app needs access to camera & sensors to start augmented reality.": "De app heeft toegang tot de camera en sensoren nodig om augmented reality te starten.",
      "Stories": "Stories",
      "For this story, access to your location is required.": "Voor deze Story is toegang tot je locatie vereist.",
      "Yes, I agree to the [privacy policy]({{privacy}}).": "Ja, ik ga akkoord met het [privacybeleid]({{privacy}}).",
      "Yes, I agree to the [terms of service]({{terms}}).": "Ja, ik ga akkoord met de [servicevoorwaarden]({{terms}}).",
      "Click continue when you are at the marked spot.": "Klik op verder als je op de gemarkeerde plek bent.",
      "GPS Unavailable": "GPS niet beschikbaar",
      "These icons represent locations you can explore. Tap on any of them to start an interactive story.": "Deze pictogrammen staan voor locaties die je kunt verkennen. Tik op een van deze locaties om een interactieve Story te starten.",
      "Show legend": "Toon legenda",
      "Map legend": "Kaart legenda",
      "Tap on screen": "Tik op het scherm",
      "Click on screen": "Klik op het scherm",
      "You finished this story.": "Je hebt deze Story voltooid.",
      "Could not load the necessary files to start this story. Please check your connection and tap to try again.": "Kon de benodigde bestanden niet laden om deze Story te starten. Controleer de verbinding en probeer het opnieuw.",
      "To login page": "Naar login pagina",
      "Go to the login page": "Ga naar de login pagina",
      "End of {{storyType}}": "Einde van {{storyType}}",
      "Redirecting": "Doorsturen",
      "Visit website": "Bezoek website",
      "Yes, I agree to the [privacy policy]({{privacy}}) and [terms of service]({{terms}}) and I have read the [statement of consent]({{consent}}).": "Ja, ik ga akkoord met het [privacybeleid]({{privacy}}) en [servicevoorwaarden]({{terms}}) en ik heb de [toestemmingsverklaring]({{consent}}) gelezen.",
      "This story is not available.": "Dit verhaal is niet beschikbaar.",
      "Restarting": "Opnieuw opstarten",
      "Next story": "Volgende story",
      "Polish": "Pools",
      "Please fill in your answer": "Vul je antwoord in",
      "You've reached the end": "Je hebt het einde bereikt",
      "Want to know more?": "Wil je meer weten?",
      "Visit this link": "Bezoek deze link",
      "Try one of these links": "Probeer een van deze links",
      "This story might interest you": "Deze story is misschien interessant",
      "These stories might interest you": "Deze stories zijn misschien interessant",
      "Yes, I agree with the [statement of consent]({{consent}}) and give permission for the processing of my personal data for this vitality program.": "Ja, ik ga akkoord met de [toestemmingsverklaring]({{consent}}) en geef toestemming voor de verwerking van mijn persoonlijke gegevens voor dit vitaliteitsprogramma.",
      "Label": "Label",
      "Please enter a valid e-mail address.": "Vul een geldig e-mail adres in.",
      "Please fill in the required fields.": "Vul de verplichte velden in.",
      "This field is required.": "Dit veld is verplicht.",
      "Log in again": "Log opnieuw in",
      "If that doesn't work, please contact the administrator.": "Als dat niet werkt, neem dan contact op met de beheerder.",
      "If that doesn't work, please contact programma@energyplatform.nl.": "Als dat niet werkt, neem dan contact op met programma@energyplatform.nl",
      "Hello there!": "Hallo daar!",
      "Tap on the marker when you are close to it.": "Tik op de locatie wanneer je er dicht bij bent.",
      "Get close to a marked location to continue.": "Kom dichter bij de gemarkeerde locatie om door te gaan.",
      "Tap on a location to continue.": "Tik op een locatie om door te gaan.",
      "By continuing, you agree that {{company}} has permission to contact you with information about products and services.": "Door verder te gaan, gaat u ermee akkoord dat {{company}} toestemming heeft om contact met u op te nemen met informatie over producten en diensten.",
      "Yes, I give permission to {{company}} to contact me with information about products and services.": "\nJa, ik geef {{company}} toestemming om contact met mij op te nemen voor informatie over producten en diensten.",
      "Please agree to conditions to continue.": "Ga akkoord met de voorwaarden om verder te gaan."
    },
    "enabled": true
  }
];
